<template>
  <div class="panel-nav">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PanelNav',
  componentName: 'PanelNav',
  props: {
    separator: {
      type: String,
      default: '>'
    },
    value: String
  },
  watch: {
    value (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>

<style lang="scss">
@include b(panel-nav) {
  font-size: 16px;

  @include e(item) {
    color: #65cea7;
    cursor: pointer;

    &__inner {
      @include is(current) {
        font-size: 18px;
        font-weight: 600;
        border-bottom: 1px solid #65cea7;
      }
    }

    &:last-child {
      .panel-nav__separator {
        display: none;
      }
    }
  }

  @include e(separator) {
    margin: 0 8px;
    color: #566874;
  }
}
</style>
